import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "./useAuth";
import { setActiveServer } from "../api/axios";

// Main and backup point at independent backends, each with its own
// CookieDomain for the refresh-token cookie (see their appsettings.json) —
// a cookie issued by one server is never sent to the other. So switching
// always requires signing in again; this hook holds the pending choice
// until the caller's confirm dialog is accepted.
const useServerSwitch = () => {
  const [pendingServerKey, setPendingServerKey] = useState(null);
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const requestSwitch = (serverKey) => setPendingServerKey(serverKey);
  const cancelSwitch = () => setPendingServerKey(null);
  const confirmSwitch = () => {
    setActiveServer(pendingServerKey);
    setPendingServerKey(null);
    setAuth({});
    navigate("/login", { state: { from: location }, replace: true });
  };

  return { pendingServerKey, requestSwitch, cancelSwitch, confirmSwitch };
};

export default useServerSwitch;
